import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../services/api.service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ServiceConfigService } from '@app/services/service-config.service';
import { ApplicationService } from '@app/services/application/application.service'
import { GoogleAnalyticsService } from '@app/services/analytics/analytics.service';
import { TokenService } from '@app/services/token/token.service';

@Component({
    selector: 'nh-register-account-validate',
    templateUrl: './register-account-validate.component.html',
    styleUrls: ['./register-account-validate.component.scss'],
    standalone: false
})
export class RegisterAccountValidateComponent implements OnInit {
  headerTitle = "";
  sectionTitle = "";
  currentLang;
  displayEbmsContent = false;
  isRegisterAccountLinkValid: boolean;
  ebmsCodeEnable: boolean;
  isMailSent = false;
  userName = "";

  constructor(private activatedRoute: ActivatedRoute, private apiService: ApiService,  public translateService: TranslateService, private titleService: Title, 
    private router: Router, private serverConfig: ServiceConfigService, private applicationservice: ApplicationService, public analytics: GoogleAnalyticsService, private token: TokenService
    ) {
      this.titleService.setTitle('Register Account');  
      this.activatedRoute.queryParams.subscribe(res => {
      if (res && res.langcd) {
        this.currentLang = res.langcd === 'sp' ? 'ES' : res.langcd
        if (this.currentLang === 'ES') {
          this.translateService.setDefaultLang('sp');
        }
      } else translateService.onDefaultLangChange.subscribe(response => this.switchLanguage(response.lang));
    }) 
  }

  switchLanguage(lang) {
    if (lang === 'sp') {
      this.currentLang = 'ES'
    } else {
      this.currentLang = 'EN'
    }
  };

  ngOnInit(): void {
    const validateLinkObj = {}
    this.activatedRoute.queryParams.subscribe((response) => {
      validateLinkObj['reasonCode'] = response.reasonCode;
      validateLinkObj['token'] = response.token;
      validateLinkObj['language'] = this.currentLang;
      validateLinkObj['userName'] = response.loginAttribute;
      this.ebmsCodeEnable = this.serverConfig.getServerConfig().ebmsCodeEnable;
      if(response.ebms === 'Y' && this.ebmsCodeEnable) {
        this.userName = response.loginAttribute;
        this.displayEbmsContent = true;
        validateLinkObj['ebmsUser'] = "Y";
      }
    })
    
    this.apiService.post('publ/users/validateLinks', validateLinkObj, { headers: new HttpHeaders({ 'pageId': 'TCRAV', 'sessionId': this.token.getSessionId() }) }).subscribe((response) => {
      response['language'] === 'ES' ? this.translateService.setDefaultLang('sp') : this.translateService.setDefaultLang('en');
      if (response['code'] === '400' || response['code'] === '600') {
        this.isRegisterAccountLinkValid = false;
        this.sectionTitle = 'REGISTRATION_LINK_EXP_SUB_TIILE';
        this.headerTitle = 'LINK_EXPRIED';
        this.displayEbmsContent ? this.analytics.trackLinkExpiredScreen('link_expired_shown') : null
      }  else if (this.displayEbmsContent === true && response['code'] === '601') {
        this.isRegisterAccountLinkValid = true;
        this.sectionTitle = 'REGISTRATION_LINK_EXP_SUB_TIILE';
        this.headerTitle = 'LINK_EXPRIED';
        this.displayEbmsContent ? this.analytics.trackLinkExpiredScreen('link_expired_acc_created_shown') : null
      }
      else if (response['code'] === '200') {
        this.isRegisterAccountLinkValid = true;
        this.sectionTitle = 'REGISTRATION_LINK_SUCC_SUB_TITLE';
        this.headerTitle = 'SUCCESS';
        if(this.displayEbmsContent === true) {
          this.applicationservice.ebmsUserName$.next(response['userName']);
          this.applicationservice.ebmsEmail$.next(response['hohEmail']);
          this.applicationservice.ebmsFirstName$.next(response['hohFName']);
          this.applicationservice.ebmsLastName$.next(response['hohLName']);
          this.applicationservice.ebmsTokenValue$.next(response['token']);
          this.router.navigateByUrl(`register-account?ebms=Y`)
        }
      }
    })
  }

  emailMe(): void {
      const validateLinkObj = {}
      validateLinkObj['language'] = "en"
      validateLinkObj['userName'] = this.userName
      validateLinkObj['ebmsAccount'] = "Y";
    this.apiService.post('publ/users/emailMeEbms', validateLinkObj, { headers: new HttpHeaders({ 'pageId': 'TCRAV', 'sessionId': this.token.getSessionId() }), observe: 'response' }).subscribe((response: any) => {
        if (response.status === 200) {
          this.isMailSent = true; 
        }
      })
  }
}
